import './delivery_supposed_date_modal.css'
import React, { useState } from 'react'
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import TextField from '@mui/material/TextField';
import CancelIcon from '@mui/icons-material/Cancel';
import SendIcon from '@mui/icons-material/Send';
import Backdrop from '@mui/material/Backdrop';
import InputAdornment from '@mui/material/InputAdornment';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import swal from 'sweetalert';
import CircularProgress from '@mui/material/CircularProgress';
import {makeStyles} from '@mui/styles';
import { change_order_state_depend_on_purchase_request} from "../../../../../../services/supplier_service";


const useStyles = makeStyles((theme) => ({
    button: { margin: 8,},
    root: {
      '& > *': {
        margin: 8,
      },
    },
    input: {
      display: 'none',
    },
  }));


function Delivery_supposed_date_modal_from_supplier_to_intern({open_deliveryDate_modal,setOpen_deliveryDate_modal,selected_products_details,request_code,id_supplier,setWait_submitting,setOrder_state}){

  const classes = useStyles();
  const [errorText,setErrorText] = useState("");
  const [waiting, setWaiting] = useState(false);

  const [supposed_date,setSupposed_date]=useState('');
  let user=JSON.parse(localStorage.getItem('user-info'))
  const id_service=user.id;

  const handleConfirmDelivery = async () => {
    setErrorText("");
    if(supposed_date===''){
        setErrorText("Champ vide !");
    }else{

        console.log(supposed_date);
        swal({
            title: "Etes-vous sûr de cette date ?",
            text: "Vous ne pourrez pas revenir en arrière!",
            icon: "warning",
            buttons: true,
        }).then(async (isConfirm) => { 
            if (isConfirm) {
              setWait_submitting(true);

                try {

                    setWaiting(true);
                    console.log("User confirmed the delivery date");

                    const requestData = {
                        performed_by:id_service,
                        request_code: request_code,
                        order_id:selected_products_details.order_id,
                        id_supplier:id_supplier,
                        delivery_date: supposed_date,
                        state: "En cours de livraison (interne)"
                    };

                    const response = await change_order_state_depend_on_purchase_request(requestData);
                    console.log("response", response);
                    setOrder_state("En cours de livraison (interne)");

                    setOpen_deliveryDate_modal(false);
                    setWaiting(false);

                    swal("Enregistrée!", "Votre date de livraison a été enregistrée.", "success");

                } catch (error) {
                    console.error("Error updating delivery date:", error.response);
                    setWaiting(false);
                }
                setWait_submitting(false);
            }
        });
        
    }
};

     

    return (
      <Dialog className="set_refuse_raison_container" fullWidth={true} maxWidth={'md'} open={open_deliveryDate_modal?true:false} onClose={()=>setOpen_deliveryDate_modal(false)} aria-labelledby="form-dialog-title" >
        <DialogTitle id="form-dialog-title">Date estimée d'arrivée de la commande</DialogTitle>
        <DialogContent>
          <div>
              <div style={{width:"100%",marginTop:"5px"}} >
                <TextField  variant='standard'
                    type="date"
                    value={supposed_date}
                    label="Date estimée de la livraison"  
                    min={(new Date()).toLocaleDateString()}  className="input_form" 
                    InputProps={{
                      inputProps: {
                        min: (new Date()).toISOString().split('T')[0], 
                      },
                      startAdornment: (
                        <InputAdornment position="start">
                          <EventAvailableIcon className="my_icon" />
                        </InputAdornment>
                      ),
                    }} 
                    onChange={(e)=>setSupposed_date(e.target.value)}
                />
              </div>
          </div>
          
     </DialogContent>
        <DialogActions>
          <div className='dialogBottom'>
            <div>
                {
                    errorText == "" 
                    ?<></>
                    :<p className={errorText ? "col-md-10 error" : "col-md-10 valid-champ"}>
                            {errorText}
                        </p>
                }
            </div>
            <div>
              <Button variant="contained" className="submit_but cancel_but" startIcon={<CancelIcon className="my_icon" />} onClick={()=>setOpen_deliveryDate_modal(false)} >
                  Annuler
              </Button>
              <Button variant="contained" className="submit_but valide_but" startIcon={<SendIcon className="my_icon" />} onClick={handleConfirmDelivery} >
                  Envoyer
              </Button> 
            </div>
          </div>
        </DialogActions>

        <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={waiting}
            >
                <CircularProgress color="inherit" />
            </Backdrop>

      </Dialog>
    )
}

export default Delivery_supposed_date_modal_from_supplier_to_intern
